// extracted by mini-css-extract-plugin
export default {"container":"Advantages_container__kjCl1","title":"Advantages_title__VYTrv","list":"Advantages_list__UVlgv","item":"Advantages_item__xW0kz"};